import { writable } from 'svelte/store';
export const contextMenuState = writable(null);
